// ProjectContext.tsx
import React, { createContext, useContext, useState, useEffect } from "react";
import useFetch from "@/hooks/useFetch";
import { useAuthContext } from "./AuthContext";

interface DeploymentUrlsProps {
  apiUrl: string;
}

interface DeploymentUrlsContextProps {
  deploymentUrls: DeploymentUrlsProps | null;
  loading: boolean;
  error: any;
}

const DeploymentUrlsContext = createContext<DeploymentUrlsContextProps>({
  deploymentUrls: null,
  loading: false,
  error: null,
});

export const DeploymentUrlsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { data, loading, error, execute } = useFetch<any>({
    url: "/deployment-urls/",
    method: "GET",
    immediate: false,
  });

  const [deploymentUrls, setDeploymentUrls] =
    useState<DeploymentUrlsProps | null>(null);

  useEffect(() => {
    execute();
  }, [execute]);

  useEffect(() => {
    if (error) {
      console.error("Error fetching deployment URLs:", error);
    }
  }, [error]);

  useEffect(() => {
    if (data?.data) {
      setDeploymentUrls(data.data);
    }
  }, [data]);

  return (
    <DeploymentUrlsContext.Provider
      value={{
        deploymentUrls,
        loading,
        error,
      }}
    >
      {children}
    </DeploymentUrlsContext.Provider>
  );
};

export const useDeploymentUrls = () => {
  const context = useContext(DeploymentUrlsContext);
  if (!context) {
    throw new Error(
      "useDeploymentUrls must be used within a DeploymentUrlsProvider",
    );
  }
  return context;
};
